var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.8257 9.35206C3.1705 12.2862 4.22274 16.7388 6.05312 19.4386C6.96678 20.7884 7.89179 22 9.15875 22C9.18263 22 9.20658 21.9995 9.2311 21.9986C9.82636 21.9743 10.2565 21.7871 10.6724 21.6062C11.1393 21.4029 11.6223 21.1927 12.3797 21.1927C13.1004 21.1927 13.5602 21.3961 14.005 21.5927C14.4433 21.7864 14.8947 21.9868 15.5618 21.974C16.9889 21.9468 17.8652 20.6394 18.6382 19.486C19.445 18.2818 19.8496 17.1125 19.9862 16.6657L19.9917 16.6479C20.0177 16.5685 19.981 16.4818 19.9064 16.4469C19.9044 16.4459 19.8968 16.4427 19.8947 16.4418C19.6434 16.3368 17.4389 15.3378 17.4157 12.6149C17.3942 10.4027 19.0695 9.2312 19.4055 9.01888L19.4211 9.00891C19.4575 8.98497 19.4829 8.94701 19.4915 8.9036C19.5001 8.86025 19.4911 8.81514 19.4667 8.77868C18.3104 7.05002 16.538 6.7895 15.8244 6.75815C15.7209 6.7476 15.614 6.74228 15.5067 6.74228C14.6686 6.74228 13.8657 7.06563 13.2207 7.32543C12.7755 7.50478 12.3909 7.65966 12.1257 7.65966C11.8276 7.65966 11.4409 7.50288 10.993 7.32137C10.3941 7.07855 9.71524 6.8034 8.9966 6.8034C8.97947 6.8034 8.96258 6.8036 8.94596 6.80392C7.27503 6.82904 5.69615 7.80556 4.8257 9.35206Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.8259 2.00013C14.814 2.04222 13.6002 2.67849 12.8747 3.54655C12.2582 4.27619 11.6558 5.49272 11.8145 6.71895C11.8245 6.79567 11.8856 6.85489 11.9611 6.86085C12.0294 6.8663 12.0992 6.86905 12.1686 6.86912C13.158 6.86912 14.2253 6.30997 14.9542 5.40964C15.7214 4.45895 16.1093 3.23888 15.992 2.14603C15.9827 2.06039 15.909 1.99678 15.8259 2.00013Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }